import { History } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LoadingSpinner } from "@/components/ui/loading-spinner";

export type PatronAuditRow = {
  id: string;
  createdAt: string;
  action: string;
  resourceType: string;
  resourceId: string | null;
  description: string | null;
};

type PatronAuditCardProps = {
  rows: PatronAuditRow[];
  loading: boolean;
};

export function PatronAuditCard({ rows, loading }: PatronAuditCardProps) {
  return (
    <Card className="border-slate-200 shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <History className="h-4 w-4" />
          Recent activity
        </CardTitle>
        <p className="text-sm text-slate-500">Audit events related to this patron account.</p>
      </CardHeader>
      <CardContent>
        {loading ? (
          <LoadingSpinner />
        ) : rows.length === 0 ? (
          <p className="text-sm text-slate-500">No audit entries found for this patron.</p>
        ) : (
          <div className="overflow-x-auto rounded-lg border border-slate-200">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b bg-slate-50 text-left text-slate-600">
                  <th className="p-2.5 font-medium">When</th>
                  <th className="p-2.5 font-medium">Action</th>
                  <th className="p-2.5 font-medium">Resource</th>
                  <th className="p-2.5 font-medium">Description</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.id} className="border-b border-slate-100 last:border-b-0">
                    <td className="whitespace-nowrap p-2.5 text-slate-600">
                      {new Date(row.createdAt).toLocaleString()}
                    </td>
                    <td className="p-2.5 font-mono text-xs">{row.action}</td>
                    <td className="p-2.5 text-xs">
                      {row.resourceType}
                      {row.resourceId ? ` · ${row.resourceId.slice(0, 8)}…` : ""}
                    </td>
                    <td className="p-2.5 text-slate-700">{row.description || "None"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
